module.exports = __webpack_public_path__ + "img/P150T_weapon_14.06e0b23f.png";